import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: '#1CB1F9',
        stroke: '#1CB1F9',
    },

    st1: {
        fill: '#FFFFFF',
    },

    st2: {
        clipPath: 'url(#SVGID_2_)',
    },

    st10: {
        fill: 'none',
    },

    st11: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st12: {
        fontSize: '15px',
        // fontWeight: '600',
    },

}));
